import {Alert, Button, Group, Text} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import type {CreatedMark} from 'src/jobs/create-job-storage'

type DraftNoticeProps = {
    restored: boolean
    created: CreatedMark | null
    onStartOver: () => void
}

export function DraftNotice({restored, created, onStartOver}: DraftNoticeProps) {
    if (restored) {
        return (
            <Alert color="blue" variant="light" data-testid="draft-restored">
                <Group justify="space-between" gap="sm">
                    <Text size="sm">Draft restored.</Text>
                    <Button size="compact-sm" variant="subtle" onClick={onStartOver}>
                        Start over
                    </Button>
                </Group>
            </Alert>
        )
    }
    if (created) {
        return (
            <Alert color="green" variant="light" data-testid="draft-already-created">
                <Text size="sm">
                    {created.label} was already created.{' '}
                    {created.jobId ? (
                        <Link to="/jobs/$jobId" params={{jobId: created.jobId}}>
                            Open it
                        </Link>
                    ) : (
                        <Link to="/projects/$projectId" params={{projectId: created.projectId}}>
                            Open it
                        </Link>
                    )}{' '}
                    or create another.
                </Text>
            </Alert>
        )
    }
    return null
}
